import { Suspense } from 'react';
import { useQueues } from 'state';
import { DisputeQueue } from 'types';
import styles from './QueueFilter.module.scss';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

export type QueueFilterProps = {
    queue: DisputeQueue | undefined,
    onQueueChange: (value: DisputeQueue) => void,
    defaultQueueId?: number
};

const placeHolderQueue: DisputeQueue = {
    queueId: 0,
    queueName: "All",
    active: true
};

const DisputeQueueFilter = (props: QueueFilterProps) => (
    <Suspense>
        <DisputeQueueDropDown {...props} />
    </Suspense>
);

const DisputeQueueDropDown = ({queue, onQueueChange, defaultQueueId}: QueueFilterProps) => {
    const queues = useQueues();
    const totalQueue = [placeHolderQueue, ...queues];
    const defaultQueue = defaultQueueId
        ? queues.find(q => q.queueId === defaultQueueId) ?? placeHolderQueue
        : placeHolderQueue;
    const queueName = totalQueue.find(({ queueId }) => queueId === queue?.queueId)?.queueName ?? defaultQueue.queueName;
    const label = `Dispute Queue: ${queueName}`;
    
    return (
        <DropDownButton 
            className={styles.control}
            items={totalQueue}
            textField='queueName'
            text={label}
            onItemClick={(e) => onQueueChange(e.item as DisputeQueue)}
        />
    );
}

export default DisputeQueueFilter;
